import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Button, Card } from 'antd';
import Login from 'screens/Login';
import AuthService from 'utils/libs/auth/AuthService';
import API from 'utils/constants/api';
import { downloadSubscriptionFile } from 'services/subscriptionFile';

const auth = new AuthService();
const authenticated = () => { try { return auth.loggedIn(); } catch (_) { return false; } };

// Keep this URL mounted through the existing login flow: no token or return URL in the link.
export default function NotificationFile({ match }) {
	useSelector(state => state.login.logged);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const request = useRef();
	useEffect(() => {
		setLoading(false); setError('');
		return () => request.current?.abort();
	}, [match.params.organizationId, match.params.userNotificationId]);
	if (!authenticated()) return <Login />;
	const download = async () => {
		request.current?.abort();
		const controller = new AbortController();
		request.current = controller;
		setLoading(true); setError('');
		try {
			const blob = await downloadSubscriptionFile({ domain: API.DOMAIN,
				...match.params, headers: auth.sendToken().headers, signal: controller.signal });
			if (controller.signal.aborted) return;
			const url = URL.createObjectURL(blob);
			const anchor = document.createElement('a');
			anchor.href = url; anchor.download = 'reporte.xlsx';
			document.body.appendChild(anchor); anchor.click(); anchor.remove();
			setTimeout(() => URL.revokeObjectURL(url), 1000);
		} catch (failure) {
			if (!controller.signal.aborted) setError('No se pudo descargar el archivo. Compruebe su sesión y seleccione la organización del informe.');
		} finally {
			if (!controller.signal.aborted) setLoading(false);
		}
	};
	return <Card title="Archivo del informe" style={{ margin: 24 }}>
		{error && <Alert type="warning" message={error} />}
		<p>Disponible únicamente para el destinatario, con la organización del informe seleccionada.</p>
		<Button loading={loading} onClick={download}>Descargar Excel</Button>
		<p><a href="/">Ir a la aplicación para seleccionar organización</a></p>
	</Card>;
}
